import { IconName } from 'components/Icon/icon-names'
import { brands } from 'domains/payment/screens/CreditCard/constants'
import { banks } from 'domains/payment/screens/DirectDebit/constants'
import { AccountPaymentResponse } from 'services/patrimony'

type Presentation = {
  title: string
  icon: IconName
  subtitle?: string
}

type Strategy = Record<
  string,
  (payment: AccountPaymentResponse) => Presentation
>

const bankSlip = (_payment: AccountPaymentResponse): Presentation => ({
  icon: 'barcode',
  title: 'Boleto',
})

const directDebit = (payment: AccountPaymentResponse): Presentation => {
  const bank =
    banks.find(({ id }) => id === String(payment.bankNumber)) || banks[0]

  return {
    icon: bank.icon,
    title: `Débito em conta ${bank?.name ?? ''}`,
    subtitle: `Ag. ••${payment.agency} Conta ••${payment.account}`,
  }
}

const creditCard = (payment: AccountPaymentResponse): Presentation => {
  const brand =
    brands.find(({ id }) => id === String(payment.brand)) || brands[0]

  return {
    icon: brand.icon,
    title: `Cartão de crédito ${brand?.name ?? ''}`,
    subtitle: `•••• ${payment.card}`,
  }
}

const converterStrategies: Strategy = {
  BANK_SLIP: bankSlip,
  DIRECT_DEBIT: directDebit,
  CREDIT_CARD: creditCard,
}

export const handlePayment = (
  payment?: AccountPaymentResponse,
): Presentation | null => {
  if (!payment) return null

  const converter = converterStrategies[payment.method]

  return converter?.(payment)
}
